<template>
  <div class="flex w-full" style="position: relative">
    <div v-if="gliders.length" class="d-flex flex-col w-full h-full">
      <v-tabs v-if="showTabs" v-model="selectedGliderIdx" align-with-title class="flex-grow-0">
        <v-tab v-for="(glider, idx) in gliders" :key="glider.id" :title="glider.libelle">
          {{ glider.libelle }}
        </v-tab>
      </v-tabs>
      <mission-detail-mission-plan
        :uiid="uiid"
        :isleft="isleft"
        :mission="store.myGetters.missionsById[gliders[selectedGliderIdx].id]"
        :isVisible="props.isVisible"
        :key="selectedGliderIdx"
      />
    </div>
    <div v-else class="w-full h-full flex flex-col mx-4 items-center justify-center title gap-2">
      <span>{{ $t('Fleet.NoGliders') }}</span>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, computed, watch, nextTick, onMounted } from 'vue'
import store from '@/store'
import { AloDbFleet } from '@/models/alodb/AloDbFleet'
import MissionDetailMissionPlan from '@/components/mission/MissionDetailMissionPlan.vue'
import { buildFleetUIStateId, FleetUiState } from '@/models/ui/FleetUiState'

const props = defineProps<{
  fleet: AloDbFleet
  isleft: boolean
  uiid: string
  isVisible: boolean
}>()

const showTabs = ref(true)
onMounted(() => {
  setTimeout(() => {
    showTabs.value = false
    nextTick(() => {
      showTabs.value = true
    })
  }, 100)
})

const fleet_uiid = computed(() => {
  return buildFleetUIStateId(props.fleet.FLE_ID!, 'detail')
})

// recupere le state de travail
const fleetState = computed(() => {
  // retourne un FleetUiState
  return store.myGetters.fleetUiStateByUiid(fleet_uiid.value)
})

const missions = computed(
  () => props.fleet.activeMissionIds?.map(id => store.myGetters?.missionsById[id])?.filter(m => !!m) ?? [],
)

const gliders = computed(() => missions.value.map(m => ({ id: m.misId, libelle: m.gliKey })))

const selectedGliderIdx = ref(0)

console.log('fleet', props.fleet)

watch(
  selectedGliderIdx,
  () => {
    fleetState.value.selectedMissionPlanMissionId =
      store.myGetters.missionsById[gliders.value?.[selectedGliderIdx.value]?.id!]?.misId || -1
  },
  { immediate: true },
)
</script>
